export default "__VITE_ASSET__C36qNgiT__"